/* ==========================================================================
   SOFT PLAYERS CLUB - shared behaviour
   Reveal on scroll, lazy background video, anchor scroll, swipe track
   arrows, Letters form tagging and analytics events.
   Loaded by every sp-* section; the guard makes sure it runs once.
   ========================================================================== */
(function () {
  if (window.SoftPlayersClub) return;

  var docEl = document.documentElement;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ROLE_KEY = 'sp_role';

  docEl.classList.add('sp-js');

  /* ---------- Analytics ------------------------------------------------ */
  function track(name, data) {
    data = data || {};
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: name };
      for (var k in data) { if (Object.prototype.hasOwnProperty.call(data, k)) payload[k] = data[k]; }
      window.dataLayer.push(payload);
    } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-sp-event]');
    if (!el) return;
    track(el.getAttribute('data-sp-event'), {
      label: (el.getAttribute('data-sp-label') || el.textContent || '').trim().slice(0, 80),
      href: el.getAttribute('href') || ''
    });
  });

  var viewSent = {};
  function sendViews(scope) {
    scope.querySelectorAll('[data-sp-view]').forEach(function (el) {
      var name = el.getAttribute('data-sp-view');
      if (!name || viewSent[name] || designMode) return;
      viewSent[name] = true;
      track(name, { path: window.location.pathname });
    });
  }

  /* ---------- Reveal --------------------------------------------------- */
  var revealObserver = null;
  if (!designMode && !reduceMotion && 'IntersectionObserver' in window) {
    revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  }

  function initReveal(scope) {
    scope.querySelectorAll('.sp-reveal:not(.is-in)').forEach(function (el) {
      if (revealObserver) revealObserver.observe(el);
      else el.classList.add('is-in');
    });
  }

  /* ---------- Background video: only the visible file loads ------------ */
  var videoObserver = null;
  if ('IntersectionObserver' in window) {
    videoObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          if (v.getClientRects().length === 0) return;
          v.muted = true;
          v.setAttribute('playsinline', '');
          if (v.preload === 'none') v.preload = 'auto';
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.05 });
  }

  function initVideos(scope) {
    if (reduceMotion || !videoObserver) return;
    scope.querySelectorAll('.sp-media__video video').forEach(function (v) {
      if (v.dataset.spBound) return;
      v.dataset.spBound = '1';
      v.muted = true;
      v.loop = true;
      v.removeAttribute('controls');
      videoObserver.observe(v);
    });
  }

  /* ---------- Roles: open the role named in the URL hash ---------------- */
  function openRole(id) {
    if (!id) return null;
    var el = document.getElementById(id);
    if (!el || !el.hasAttribute('data-sp-role')) return el;
    var details = el.querySelector('details');
    if (details) details.open = true;
    return el;
  }

  /* Height of whatever is stuck to the top of the screen (sticky header,
     announcement bar). Measured live, so it works on desktop and mobile. */
  function topOffset() {
    var bottom = 0;
    var xs = [window.innerWidth * 0.25, window.innerWidth * 0.5, window.innerWidth * 0.75];
    xs.forEach(function (x) {
      var node = document.elementFromPoint(x, 2);
      while (node && node !== document.body && node !== document.documentElement) {
        var pos = getComputedStyle(node).position;
        if (pos === 'fixed' || pos === 'sticky') {
          var r = node.getBoundingClientRect();
          if (r.top <= 2 && r.bottom < window.innerHeight * 0.5) bottom = Math.max(bottom, r.bottom);
          break;
        }
        node = node.parentElement;
      }
    });
    return bottom;
  }

  function scrollToEl(el, smooth) {
    var y = el.getBoundingClientRect().top + window.pageYOffset - topOffset();
    window.scrollTo({ top: Math.max(0, Math.round(y)), behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
  }

  function openRoleFromHash() {
    var id = decodeURIComponent(window.location.hash.slice(1));
    var el = openRole(id);
    if (el && el.hasAttribute('data-sp-role')) {
      /* run twice: after the browser's own jump, and again once images/fonts settle */
      setTimeout(function () { scrollToEl(el, false); }, 60);
      setTimeout(function () { scrollToEl(el, false); }, 700);
    }
  }
  window.addEventListener('hashchange', openRoleFromHash);

  /* ---------- Smooth anchor scroll ------------------------------------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.sp a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    if (!id) return;
    var target = openRole(id);
    if (!target) return;
    e.preventDefault();
    scrollToEl(target, true);
    if (history.replaceState) history.replaceState(null, '', '#' + id);
  });

  /* ---------- Track arrows --------------------------------------------- */
  function initSliders(scope) {
    scope.querySelectorAll('[data-sp-slider]').forEach(function (wrap) {
      if (wrap.dataset.spBound) return;
      wrap.dataset.spBound = '1';
      var track = wrap.querySelector('.sp-track');
      var prev = wrap.querySelector('[data-sp-prev]');
      var next = wrap.querySelector('[data-sp-next]');
      if (!track) return;

      function step() {
        var item = track.firstElementChild;
        if (!item) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return item.getBoundingClientRect().width + gap;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Letters form --------------------------------------------- */
  function initLetters(scope) {
    scope.querySelectorAll('form[data-sp-letters]').forEach(function (form) {
      if (form.dataset.spBound) return;
      form.dataset.spBound = '1';
      form.addEventListener('submit', function () {
        var tags = form.querySelector('input[name="contact[tags]"]');
        var role = null;
        try { role = window.localStorage.getItem(ROLE_KEY); } catch (e) {}
        if (tags && role && tags.value.indexOf('role-' + role) === -1) {
          tags.value = tags.value + ',role-' + role;
        }
        track('sp_letters_signup', { role: role || '' });
      });
    });
  }

  /* ---------- Init ----------------------------------------------------- */
  function init(scope) {
    scope = scope || document;
    initReveal(scope);
    initVideos(scope);
    initSliders(scope);
    initLetters(scope);
    sendViews(scope);
  }

  window.SoftPlayersClub = {
    init: init,
    track: track,
    setRole: function (handle) {
      try { window.localStorage.setItem(ROLE_KEY, handle); } catch (e) {}
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  if (document.readyState === 'complete') openRoleFromHash();
  else window.addEventListener('load', openRoleFromHash);

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();